import _ from 'lodash';
import { AiMbl } from '../../../../fms.core/AiMbl';
import { MblStatusViewModel, AiAirLineEvents, AirMblStatusMap } from '../../../../fms.core/MblStatusViewModel';
import { PimsCntrEvent } from '../../../../fms.core/PimsCntrEvent';
import { AeMbl } from '../../../../fms.core/AeMbl';
import { appendLine, formatAmount } from '../../../../util';

export function prepareAiMawbModelForView(model: AiMbl | AeMbl) {
  if (!model) {
    return;
  }

  if(!model.milestone) {
    model.milestone = new MblStatusViewModel();
  }

  if(model.milestone.eventItemList.length > 0) {
    _.remove(model.milestone.eventItemList);
  }

  
  if(model.milestone.eventItemList == null) model.milestone.eventItemList = [];

  if(model.milestone.eventItemList.length <= 0) { //airline status
    model.milestone.cntrItemList.forEach(c => { //pims
      AiAirLineEvents.forEach((enumEvent) => {
        const smitem = AirMblStatusMap.get(enumEvent);
        if(!smitem) return;
        model.milestone?.eventItemList?.push(new PimsCntrEvent({
          pimsCntrId: c.id,
          cntrNo: c.cntrNo,
          pickupNo: c.pickupNo,
          name: smitem.label,
          lastDate: _.get(c, smitem.pimsCntrDate??''),
          locName: _.get(c, smitem.pimsCntrLoc??''),
          seq: enumEvent,   //seqNo++,
          isVisible: true
        }));
      });
    });
  }
}


export function formatGrossWeight(model: AiMbl, country: string): string {
  if (country === "U.S.") {
    return appendLine(
      `${formatAmount(model.grossWeight)} KGS`,
      `${formatAmount(model.lGrossWeight)} LBS`
    );
  }
  else {
    return `${formatAmount(model.grossWeight)} KGS`;
  }
}

export function formatChargeableWeight(model: AiMbl, country: string): string {
  if (country === "U.S.") {
    return appendLine(
      `${formatAmount(model.chgWeight)} KGS`,
    `${formatAmount(model.lChgWeight)} LBS`
    );
  }
  else {
    return `${formatAmount(model.chgWeight)} KGS`;
  }
}